import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
})
export class TableHeaderComponent implements OnInit {
  @Input() width: any = 1;
  @Input() filterList;
  @Input() sortingVariable: any;
  @Input() sortingDirection: any;
  @Input() searchable = false;

  @Input() header;
  @Input() variable;

  @Output() clickSorting = new EventEmitter<string>();
  constructor() { }

  ngOnInit() { }

  clickFilter() {

  }
  clickShorting() {
    if (this.sortingVariable) {
      this.clickSorting.emit(this.sortingVariable);
    }
  }
}
